import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBack,
  MdArrowForward,
  MdAttachFile,
  MdCancel,
  MdMenu,
  MdMoreHoriz,
  MdOutlineImage,
} from "react-icons/md";

import { useNavigate, useParams } from "react-router";
import { isEmpty } from "../functions/isEmpty";
import "../styles/AdTemplateFlyer.css";

export default function AdTemplateFlyer({
  mobile,
  companyData,
  authToken,
  nextVideo,
  companyName,
  companyWebsite,
  imgURL,
  isPlaying,
}) {
  const [isUploading, setIsUploading] = useState([]);

  useEffect(() => {
    let timer;

    if (isPlaying) {
      // Start the timer only if the video is not playing
      timer = setTimeout(() => {
        nextVideo();
      }, 5000); // 5 seconds
    }

    // Cleanup function to clear the timer when the component unmounts or isPlaying changes
    return () => clearTimeout(timer);
  }, [isPlaying, nextVideo]);
  return (
    <div className="adtemplateflyer">
      <div className="adtemplateflyer_top">
        <img
          src={
            isEmpty(imgURL)
              ? "https://www.developercloud.letsfluence.com/api/images/placeholder/profilbildplaceholder.jpg"
              : imgURL
          }
          className="adtemplateflyer_top_img"
        />
      </div>
      <div className="adtemplateflyer_middle">
        {isEmpty(companyName) ? "Dein Firmenname" : companyName}
      </div>
      <div className="adtemplateflyer_bottom">
        {isEmpty(companyWebsite) ? "Deine Website" : companyWebsite}
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 33px;
  color: #575757;
`;

const ArrowBack = styled(MdArrowBack)`
  font-size: 20px;
  color: #636363;
  margin-top: 2px;
`;

const MoreIcon = styled(MdMoreHoriz)`
  font-size: 20px;
  color: #474747;
`;

const ImageIcon = styled(MdOutlineImage)`
  font-size: 30px;
  color: #474747;
`;

const SendIcon = styled(MdArrowForward)`
  font-size: 20px;
  color: #ffffff;
  transform: rotate(-90deg);
`;

const FileIcon = styled(MdAttachFile)`
  font-size: 20px;
  color: #474747;
`;

const CancelIcon = styled(MdCancel)`
  font-size: 25px;
  color: #575757;
`;
